// Enum option lists mirrored from the Employee Management API contract.

export const DEPARTMENT_OPTIONS = [
    { value: 'SECURITY', label: 'Security' },
    { value: 'MAINTENANCE', label: 'Maintenance' },
    { value: 'HOUSEKEEPING', label: 'Housekeeping' },
    { value: 'ADMINISTRATION', label: 'Administration' },
    { value: 'ACCOUNTS', label: 'Accounts' },
    { value: 'MANAGEMENT', label: 'Management' },
    { value: 'OTHER', label: 'Other' },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
    { value: 'PERMANENT', label: 'Permanent' },
    { value: 'CONTRACT', label: 'Contract' },
    { value: 'TEMPORARY', label: 'Temporary' },
    { value: 'PART_TIME', label: 'Part Time' },
];

// Employee-type (role) catalog status codes.
export const ROLE_STATUS_OPTIONS = [
    { value: 'A', label: 'Active' },
    { value: 'I', label: 'Inactive' },
];

// Normalise an employee row's active flag (API returns a number 1/0).
export const isEmployeeActive = (emp) =>
    emp?.is_active === 1 || emp?.is_active === true || String(emp?.is_active) === '1';

// Full name helper.
export const employeeFullName = (emp) =>
    (emp?.name
        || [emp?.first_name, emp?.last_name].filter(Boolean).join(' ').trim()
        || '-');
